import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext({ c: (k, fb) => fb, content: {} });
export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  useEffect(() => { api.get("/content").then((r) => setContent(r.data || {})).catch(() => {}); }, []);
  const c = (key, fallback = "") => (content[key] !== undefined && content[key] !== "" ? content[key] : fallback);
  return <ContentContext.Provider value={{ content, c }}>{children}</ContentContext.Provider>;
}
